import React from "react";
import {
  Svg,
  Line,
  Polyline,
  Polygon,
  Path,
  Rect,
  Circle,
  Ellipse,
  Text,
  Tspan,
  G,
  Stop,
  ClipPath,
  LinearGradient,
  RadialGradient,
} from "@react-pdf/renderer";

export const Top = ({color} : {color: string}) => {
  // @ts-ignore
  return (<Svg id="Calque_1" data-name="Calque 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17.64 113.58">
  <G fill={color}>
    <Polygon points="5.85 35.59 11.44 35.59 11.44 5.08 17.29 5.08 17.29 0 0 0 0 5.08 5.85 5.08 5.85 35.59"/>
    <Path d="M8.64,74.99c2.75,0,4.85-.77,6.3-2.31,1.46-1.54,2.19-3.75,2.19-6.63v-18.51c0-2.88-.73-5.09-2.19-6.63-1.46-1.54-3.56-2.31-6.3-2.31s-4.85.77-6.3,2.31S.15,44.66.15,47.54v18.51c0,2.88.73,5.09,2.19,6.63s3.56,2.31,6.3,2.31ZM5.74,47.18c0-1.29.26-2.19.79-2.72.52-.53,1.23-.79,2.11-.79s1.58.26,2.11.79c.53.53.79,1.43.79,2.72v19.22c0,1.29-.26,2.2-.79,2.72-.53.53-1.23.79-2.11.79s-1.59-.26-2.11-.79c-.53-.52-.79-1.43-.79-2.72v-19.22Z"/>
    <Path d="M15.58,80.23c-1.37-1.49-3.47-2.24-6.28-2.24H1.07v35.59h5.59v-13.37h2.64c2.81,0,4.91-.75,6.28-2.24,1.37-1.49,2.06-3.68,2.06-6.56v-4.63c0-2.88-.69-5.07-2.06-6.56ZM12.05,91.77c0,1.29-.24,2.17-.71,2.64-.47.48-1.15.71-2.03.71h-2.64v-12.05h2.64c.88,0,1.56.24,2.03.71.47.48.71,1.36.71,2.64v5.34Z"/>
  </G>
</Svg>
);
};

export default Top;
